import ApplicationController from './application_controller'

export default class extends ApplicationController {
  printDisplay () {
    window.print()
    return false
  }
}
